import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS   } from '@angular/common/http';
// import { MockBackend } from '@angular/http/testing';

import { AuthRoutingModule } from './auth-routing.routing';
import { AuthComponent } from './auth.component';
import { AlertComponent } from './_directives/alert.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthGuard } from './_guards/auth.guard';
import { AlertService } from './_services/alert.service';
import { AuthenticationService } from './_services/authentication.service';
import { UserService } from './_services/user.service';
import { JwtInterceptor } from './interceptors/jwt.interceptor';

import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION, PB_DIRECTION } from  'ngx-ui-loader';
import { HmacGenerationService, IPAddressService } from './_services';
// import { fakeBackendProvider } from './_helpers/index';
// import { WebConfig } from '../WebConfig';

@NgModule({
    declarations: [
        AuthComponent,
        AlertComponent,
        LogoutComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        HttpClientModule ,
        AuthRoutingModule,
        NgxUiLoaderModule
    ],
    providers: [
        AuthGuard,
        AlertService,
        AuthenticationService,
        UserService,
        IPAddressService,
        HmacGenerationService,
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
        // api backend simulation
        // fakeBackendProvider,
        // MockBackend,
        // BaseRequestOptions,
        // WebConfig,
    ],
    // entryComponents: [AlertComponent],
})

export class AuthModule {
}